module.exports = __webpack_public_path__ + "media/images/vector_admin03-39e5e49cd88288d6f56c405789aec713.svg";